import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PortalIcon from './PortalIcon';
import Cotizador from './Cotizador';

export default function PortalCotizador() {
  const { authRequestJson } = useAuth();
  const [clienteId, setClienteId] = useState('');

  useEffect(() => {
    let active = true;
    authRequestJson('/portal/me').then((response) => {
      if (active) setClienteId(response?.data?.cliente?.id || '');
    }).catch(() => {});
    return () => { active = false; };
  }, [authRequestJson]);

  return (
    <div className="portal-app portal-quote-page">
      <div className="portal-wrap">
        <header className="portal-page-header--split"><div><p className="portal-kicker">Herramientas / Cotizador</p><h1>Calculá tu envío</h1><p>Usá la misma lógica tarifaria que alimenta tus pedidos de Tiendanube. El cliente y el origen quedan asociados a tu cuenta para futuras tarifas diferenciales.</p></div><Link className="portal-btn portal-btn--outline" to="/portal"><PortalIcon name="back" size={16} /> Volver al resumen</Link></header>
        <div className="portal-card" style={{ padding: 22 }}><Cotizador defaultClienteId={clienteId} hideClienteSelector /></div>
      </div>
    </div>
  );
}
